// @noflow
import type { MessagingHubResponse } from './types';
import { get, put } from '../../utils/api';

export async function fetchMessagingHub({
  limit = 20,
  cursor,
  search,
  statuses,
  propertyIds,
  householdStatuses,
  forcePropertyScope,
}: {
  limit?: number,
  cursor?: string,
  search?: string,
  statuses?: string[],
  propertyIds?: string[],
  householdStatuses?: string[],
  forcePropertyScope?: string,
}): Promise<MessagingHubResponse> {
  const params = new URLSearchParams();

  params.append('limit', limit.toString());

  if (cursor) {
    params.append('cursor', cursor);
  }

  if (search) {
    params.append('search', search);
  }

  if (statuses && statuses.length > 0) {
    statuses.forEach((status) => params.append('status', status));
  }

  householdStatuses?.forEach((householdStatus) =>
    params.append('householdStatus', householdStatus),
  );

  // When forcePropertyScope is set (property-level view), always use that property
  // Otherwise, use the propertyIds from filters
  if (forcePropertyScope) {
    params.append('propertyId', forcePropertyScope);
  } else if (propertyIds && propertyIds.length > 0) {
    propertyIds.forEach((propertyId) =>
      params.append('propertyId', propertyId),
    );
  }

  return get(
    `${
      import.meta.env.REACT_APP_TWO_WAY_API_URL || ''
    }/hub/conversations?${params.toString()}`,
    { isOtherApi: true },
  );
}

export async function updateConversation(
  conversationId: string,
  body: { conversationStatus: string, propertyId: string },
): Promise<void> {
  return put(
    `${
      import.meta.env.REACT_APP_TWO_WAY_API_URL || ''
    }/conversations/${conversationId}`,
    JSON.stringify(body),
    { isOtherApi: true },
  );
}
